<script setup lang="ts">
import { computed } from "vue";

import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { min = 1, max = 100 } = defineProps<{
  min?: number;
  max?: number;
}>();

const model = defineModel<number>();

const options = computed(() =>
  Array.from({ length: max - min + 1 }, (_, i) => ({
    label: t("website.societym.panel_person", { n: min + i }),
    value: min + i,
  })),
);
</script>

<template>
  <FormControl
    :label="$t('website.societym.panel_attendees')"
    name="attendees"
    input-type="select"
    data-testid="form-control-attendees"
  >
    <FormSelect
      :placeholder="$t('website.societym.panel_attendees')"
      :options
      v-model="model"
      class="attendees-input__select"
      data-testid="form-select-attendees"
    />
    <IconPeople
      class="attendees-input__icon"
      data-testid="form-icon-attendees"
    />
  </FormControl>
</template>

<style lang="scss">
.attendees-input {
  &__select {
    appearance: none;

    &.form-select {
      padding-inline-end: calc(
        1rem + 21px + 1rem
      ); // padding-right + icon width + padding-left
    }
  }

  &__icon {
    position: absolute;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
    pointer-events: none;
  }
}
</style>
